import {
  GET_ALL_ROLES,
  GET_ALL_ROLES_RESPONSE_SUCCESS,
  CREATE_ROLE_NAME,
  DELETE_ROLE,
  DELETE_ROLE_RESPONSE_SUCCESS,
  API_ERROR,
  EDIT_ROLE,
  EDIT_ROLE_RESPONSE_SUCCESS,
  ASSIGN_ROLE_NAME,
} from "./actionTypes"

export const getAllRoles = () => {
  return {
    type: GET_ALL_ROLES,
  }
}
export const getAllRolesResponseSuccess = payload => ({
  type: GET_ALL_ROLES_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createRole = (payload, toggle) => {
  return {
    type: CREATE_ROLE_NAME,
    payload: payload,
    toggle,
  }
}

// ------------------------------------------------------- DELETE ------------------------------------------------------------

export const deleteRole = payload => ({
  type: DELETE_ROLE,
  payload: payload,
})

export const deleteExtensionsResponse = payload => ({
  type: DELETE_ROLE_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------------------------- EDIT ------------------------------------------------------------

export const editRole = (payload, toggle) => ({
  type: EDIT_ROLE,
  payload: payload,
  toggle,
})

export const editRoleResponse = payload => ({
  type: EDIT_ROLE_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------------------------- ASSIGN ROLES ------------------------------------------------------------
export const assignRoles = (payload, roleId, toggle) => {
  return {
    type: ASSIGN_ROLE_NAME,
    payload: payload,
    roleId,
    toggle,
  }
}
